import { RadioGroup } from '@headlessui/react'
import { c, FC } from 'lib/component-utils'
import { useTheme, ThemeMode } from 'lib/colors'
import { Sun, Moon, Monitor } from 'lucide-react'
import { useIntl } from 'lib/intl-utils'

const options: { value: ThemeMode; icon: typeof Sun }[] = [
  { value: 'system', icon: Monitor },
  { value: 'light', icon: Sun },
  { value: 'dark', icon: Moon },
]

const ThemeSelect: FC = ({ className }) => {
  const { t } = useIntl()
  const { themeMode, setThemeMode } = useTheme()

  return (
    <RadioGroup
      value={themeMode}
      onChange={setThemeMode}
      className={c`flex w-fit items-center bg-gray-200/60 border border-gray-200/60 rounded-lg p-[2px] gap-[2px] ${className}`}
    >
      {options.map((option) => {
        const Icon = option.icon
        return (
          <RadioGroup.Option
            key={option.value}
            value={option.value}
            className={({ checked }) =>
              c`outline-none focus-visible:ring-2 focus-visible:ring-primary-500 transition-colors duration-200 cursor-pointer rounded-md flex flex-col items-center justify-center gap-1 py-2 px-3 ${checked} text-gray-900 bg-white shadow-sm | text-gray-500 hover:bg-gray-50`
            }
          >
            <Icon className="w-5 h-5" />
          </RadioGroup.Option>
        )
      })}
    </RadioGroup>
  )
}

export default ThemeSelect
